import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import SignUp from './SignUp';

/**
 * Smart gate for /auth/signup :
 * - With `?invite=TOKEN&plan=...` → show SignUp (paid customer activating their account)
 * - Without invite → redirect to /apply (free/B2B leads go through the access request funnel)
 */
export default function SignUpGate() {
    const [params] = useSearchParams();
    const invite = params.get('invite');
    if (!invite) {
        return <Navigate to="/apply" replace />;
    }
    return <SignUp />;
}
